import React, { useState, useEffect } from 'react'
import './index.less'
import { useAppSelector } from '@/hooks'
import Form from '@/components/Compare/Form'

export default function FormCompare() {
  const [currentTags, setCurrentTags] = useState<string[]>([])
  const localInfo = useAppSelector((state) => state.compareInfo.localInfo)

  useEffect(() => {
    const newCurrentTags: string[] = []
    for (let i = 0; i < localInfo.length; i++) {
      const wuxiangTags = localInfo[i].tags.filter((item) => item.typeName === '物象')
      if (wuxiangTags.length > 0) {
        for (let j = 0; j < wuxiangTags[0].tags.length; j++) {
          if (!newCurrentTags.includes(wuxiangTags[0].tags[j])) {
            newCurrentTags.push(wuxiangTags[0].tags[j])
          }
        }
      }
    }
    setCurrentTags(newCurrentTags)
  }, [localInfo])
  return (
    <div className='compare-form'>
      <Form currentTags={currentTags} />
    </div>
  )
}
